import { Component, OnInit, PipeTransform } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DecimalPipe } from '@angular/common';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalServiceService } from '../../shareModule/services/local-service.service';


@Component({
	selector: 'app-admin-forum-polling',
	templateUrl: './admin-forum-polling.component.html',
	styleUrls: ['./admin-forum-polling.component.scss'],
})
export class AdminForumPollingComponent implements OnInit {
	// countries$: Subject<Country[]> =new Subject();
	categories: Array<any>;
	category: any = {};
	filter = new FormControl('');

	poll: any = {
		name: "",
		startDate: "",
		endDate: "",
		polls: []
	};
	polls: any = {
		isLoading: false,
		data: [],
		currentPage: 1
	};
	private modalRef: any;

	/**
	 * Constructor
	 */
	constructor(
		// private modalService: NgbModal,
		private toastr: ToastrService,
		private local: LocalServiceService,
		private auth: AuthServiceService,
		private fb: FormBuilder,
		private spinner: NgxSpinnerService,
		private modalService: NgbModal,
	) {
		// this.countries$ = this.filter.valueChanges.pipe(
		// 	startWith(''),
		// 	map((text) => search(text)),
		// );

	}

	ngOnInit(): void {
		this.initPoll()
	}

	openForm(modal: any, item: any = {}) {
		this.modalService.dismissAll()
		this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'poll_form_modal' })
		this.poll = item
		this.poll.polls = item?.poll_details ?? []
	}

	deletePoll(id: any) {
		const getConfirm = confirm("are you sure ?")

		if (getConfirm)
			this.auth.poll_delete(id).subscribe((response: any) => {
				alert("Poll has been deleted")
				this.initPoll()
			})
	}

	initPoll() {
		this.polls.isLoading = true
		this.auth.poll_fetch({isAll:true}).subscribe((response: any) => {
			this.polls = response.body
		})
	}

	addPollsChild() {
		this.poll.polls = [
			...this.poll.polls,
			{}
		]
	}

	removePollsChild(i: number) {
		this.poll.polls = this.poll.polls.filter((row: any, index: number) => index != i)
	}

	storePoll() {
		const poll = this.poll
		if (poll.name == '' || poll.startDate == '' || poll.endDate == '' || poll.polls.length < 1)
			return alert("Please fill the inputs.")

		this.poll.uuid = this.local.generateUUID()

		this.auth.poll_store(poll).subscribe((response: any) => {
			this.initPoll()
			this.modalService.dismissAll()
			this.toastr.success("successfully added poll")
		}, (e) => {
			this.toastr.error('failed to add poll')
		})
	}

}
